/**
 * machineLog.js — Ereignisspeicher für den Maschinenraum.
 *
 * Zweck: Der Maschinenraum soll zeigen, was beim Ver- und Entschlüsseln
 * tatsächlich passiert ist, auch wenn er erst nach dem Vorgang geöffnet wird.
 *
 * Bewusste Eigenschaften dieses Speichers:
 *  - Er liegt ausschließlich im Arbeitsspeicher. Kein localStorage, kein
 *    IndexedDB, keine Datei, kein Netzwerk. Ein Neuladen der Seite leert ihn.
 *  - Er nimmt keine Nutzdaten auf. Erlaubt sind Zahlen, kurze Bezeichner und
 *    die Prüfsumme aus dem AES-GCM-Auth-Tag. Klartextbytes, Schlüssel,
 *    Passwörter und signierte URLs gehören hier nicht hinein.
 *  - Er wird beim Sperren des Tresors gelöscht (clearMachineLog).
 *
 * Wer das nachprüfen will: Diese Datei ist kurz. Sie enthält kein fetch,
 * kein XMLHttpRequest, kein sendBeacon und keinen Zugriff auf einen Speicher,
 * der ein Neuladen überlebt. Genau das ist der Punkt.
 */

const MAX_EVENTS = 120;

let events = [];
let seq = 0;
const listeners = new Set();

function notify() {
  for (const fn of listeners) {
    try {
      fn(events);
    } catch {
      /* ein defekter Zuhörer darf den Upload nicht anhalten */
    }
  }
}

/**
 * Ein Ereignis ablegen. Aufrufer übergeben nur Zahlen und kurze Bezeichner.
 */
export function pushMachineEvent(entry) {
  seq += 1;
  const record = { ...entry, id: seq, at: Math.round(performance.now()) };
  events = events.length >= MAX_EVENTS
    ? [...events.slice(events.length - MAX_EVENTS + 1), record]
    : [...events, record];
  notify();
}

export function getMachineEvents() {
  return events;
}

export function clearMachineLog() {
  if (events.length === 0) return;
  events = [];
  notify();
}

/** React abonniert hierüber, useSyncExternalStore-kompatibel. */
export function subscribeMachineLog(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
